<script>
import { TemplateAnnotations } from '@magnolia/template-annotations';
import { insertComments, mgnlRender } from './helper';
import PersonalizationService from './PersonalizationService';
import EditorContextHelper from './EditorContextHelper';

const EditableComponent = {
  name: 'EditableComponent',
  inject: ['config', 'templateAnnotations'],
  props: ['content', 'index'],
  computed: {
    renderingContent() {
      return TemplateAnnotations.generateMissingAreas(
        this.personalizedContent,
        this.templateAnnotations.value
      );
    }
  },
  data() {
    return {
      personalizedContent: this.content
    };
  },
  methods: {
    writeAnnotation() {
      if (!this.content) {
        return;
      }
      if (
        this.templateAnnotations.value &&
        this.templateAnnotations.value[this.renderingContent['@path']]
      ) {
        const commentOpen = this.templateAnnotations.value[this.renderingContent['@path']];
        insertComments(this.$el, commentOpen, '/cms:component');
        EditorContextHelper.refresh();
      }
    }
  },
  async mounted() {
    EditorContextHelper.inEditorAsync().then((inEditor) => {
      if (inEditor) {
        this.writeAnnotation();
      }
      // Set variant after we receive selected variants from the server
      this.personalizedContent = PersonalizationService.getVariant(
        this.content,
        this.templateAnnotations.value
      );
    });
  },
  render() {
    return mgnlRender(
      this.renderingContent,
      this.config.componentMappings,
      this.config.fallbackComponent,
      {},
      this.index
    );
  }
};
export default EditableComponent;
</script>
